import {Injectable} from '@angular/core';
import {Router} from "@angular/router";
import {Location} from "@angular/common";

@Injectable()
export class RouterService {
    constructor(private location: Location,
                private router: Router) {}

    backRouteIntercept(url?: string): void {
        //TODO should be used to intercept the back button and then redirecting to the given url
    }
}